// TODO: this function might not be necessary
import authRules from '../authRules';

const previousPostings = (user) => {
  const { lastPostings } = user.securityLevels;
  if (lastPostings >= authRules.previousPostings.lastPostings) {
      return true;
  } else {
      return false;
    }
  }

export default previousPostings;



// WEBPACK FOOTER //
// ./src/AuthLogic/rules/previousPostings.js